module.exports = __webpack_public_path__ + "static/map-5cfcb82d1680e62ca3d98db4f595db56.jpg";